/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IRootPathSelectorFacade {
  initializeRootPath(): any;
  setRootPath(fileName: string): void;
  selectRootPath(): Observable<string>;
}

export const ROOT_PATH_FACADE_TOKEN = new InjectionToken<IRootPathSelectorFacade>('ROOT_PATH_FACADE_TOKEN');
